export const musicData = [
  {
    id: "1",
    title: "Ana Chaabek",
    description: "Ana Chaabek est une opérette Tunisienne qui rassemble cent artistes de toute la Tunisie. Elle raconte la beauté des territoires, allant du Sud au Nord et fait intervenir un orchestre symphonique, une Chorale d'enfants ainsi que 13 Chanteurs et chanteuses tunisiens de grande envergure",
    soundPath: "/ana-chaabek.mp3",
    about: "Plus",
    link: "https://www.youtube.com/watch?v=_TiKQLguWPc",
  },
  {
    id: "2",
    title: "Baba Ameur",
    description: "Baba Ameur du nom du père mais également du Saint Sidi Ameur Mzoughi est un hommage à la Hadhra, le tout premier répertoire que l'artiste a joué sur scène à l'âge de 12 ans.Avec Ghassen Fendri, Il y fusionne avec parcimonie les origines de cette musique avec l'électro et le rock.",
    soundPath: "/baba-ameur.mp3",
    about: "Plus",
    link: "https://open.spotify.com/intl-fr/track/2NQbQLJa3EAX0AbEPAJytO?si=de14984b0ef449c3",
  },
  {
    id: "3",
    title: "Orion",
    description:
      "Orion est le nom d’une étoile du ciel qui guide les Touaregs pendant leurs voyages. Une sorte de boussole qui leur montre le chemin du Nord. Toutefois, cette étoile n’est pas toujours visible. Mais est-ce le meilleur chemin ? le titre Orion célèbre en effet le retour au fief après de longs voyages.",
    soundPath: "/orion.mp3",
    about: "Plus",
    link: "https://open.spotify.com/intl-fr/track/01bImbEyVZQNURYqejOoXi?si=2b7a233e65794387",
  },
  {
    id: "4",
    title: "Tunisian Rhapsody",
    description:
      "‘Rhapsody Tunisienne’ est un des morceaux phare de cet album. Basé sur un rythme ternaire maghrébin, il nous livre une énergie particulièrement fraîche et vivifiante émanant d’une mélodie orientale d’une lucidité époustouflante. Les percussions y sont à l’honneur avec différentes couleurs de l’Afrique du Nord, illustrant les influences de l’artiste.",
    soundPath: "/tunisian-rhapsody.mp3",
    about: "Plus",
    link: "https://open.spotify.com/intl-fr/track/0esvZitNaApTBsAPPOaWWE?si=2bec7fd35ca646bd",
  },
  {
    id: "5",
    title: "Egyptian Notice",
    description:
      "Nous voici en Egypte avec un morceau binaire,intuitif, à l’esprit moderne. Rock et R&B d’uncôté, wehda orientale de l’autre,Egyptian Noticese nourrit des contrastes avec un thème groovycomposé sur le fameux maqâm égyptien bayâti.",
    soundPath: "/egyptian-notice.mp3",
    about: "Plus",
    link: "https://open.spotify.com/intl-fr/track/7yufMoY0ZCTDmz2lKbW441?si=6bcfb0329b914171",
  },
];
